import React, { useEffect } from 'react';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import RetryApiAlert from '../../../fallback-screens/components/retry-api-alert/RetryApiAlert';
import { GenericPageShimmer } from '../../../loader/components/generic-page-shimmer/GenericPageShimmer';
import { useResolvedComponent } from '../../hooks/useResolvedComponent';

export function HdResolvedComponent({
  Component,
  canActivate,
  resolve,
  parallelExecution=false
}: {
  Component: React.FC<any>;
  canActivate?: Array<() => Promise<boolean> | boolean>;
  resolve?: { [key: string]: Promise<any> | any };
  parallelExecution?:boolean // this execute all apis in canActivate in parallel
}) {
  const { resolveComponent, resolvedData, resolvingRoute, canActivateRoute, routeActivationError } =
    useResolvedComponent({
      parallelExecution,
      canActivate,
      resolve
    });

  useEffect(() => {
    resolveComponent();
  }, []);

  const dataIdGenerator = getDataIdGenerator('resolved-component');

  return (
    <>
      {resolvingRoute ? <GenericPageShimmer /> : null}

      {canActivateRoute ? <Component {...resolvedData} /> : null}

      {routeActivationError ? (
        <RetryApiAlert
          error={routeActivationError}
          actionHandler={() => resolveComponent()}
          dataId={dataIdGenerator('')}
        />
      ) : null}
    </>
  );
}
